<template>
  <div class="search-paginator">
    <button
      type="button"
      class="page-button"
      v-on:click="first()"
      :disabled="currentPage === 1"
    >
      <div class="icon"><i class="fas fa-chevron-double-left fa-fw"></i></div>
    </button>
    <button
      type="button"
      class="page-button"
      v-on:click="previous()"
      :disabled="currentPage === 1"
    >
      <div class="icon"><i class="fas fa-chevron-left fa-fw"></i></div>
    </button>

    <!-- PAGES -->
    <button
      type="button"
      class="page-button"
      :class="{ 'active-page': p.isActive }"
      v-on:click="setNewPage(p.label)"
      v-for="p in getPageArray()"
    >
      {{ p.label }}
    </button>

    <button
      type="button"
      class="page-button"
      v-on:click="next()"
      :disabled="currentPage === maxPage"
    >
      <div class="icon"><i class="fas fa-chevron-right fa-fw"></i></div>
    </button>
    <button
      type="button"
      class="page-button"
      v-on:click="last()"
      :disabled="currentPage === maxPage"
    >
      <div class="icon"><i class="fas fa-chevron-double-right fa-fw"></i></div>
    </button>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";

export default {
  name: "SearchPaginator",
  data() {
    return {
      maxPage: 10,
      pagesDisplayed: 5,
      pagesOnSide: 0, // Will be set in mounted based on pagesDisplayed
      pageLeftover: 0, // Will be set in mounted based on pagesDisplayed
    };
  },
  computed: {
    ...mapState({
      currentPage: (state) => state.search.options.currentPage,
      selectedLimit: (state) => state.search.options.selectedLimit,
      totalResults: (state) => state.search.options.totalResults,
    }),
  },
  watch: {
    totalResults(newVal, oldVal) {
      this.setMaxPage();
    },
    selectedLimit(newVal, oldVal) {
      this.setMaxPage();
    },
  },
  mounted() {
    this.maxPage = Math.ceil(this.totalResults / this.selectedLimit);
    this.pagesOnSide = Math.floor(this.pagesDisplayed / 2);
    this.pageLeftover = this.pagesDisplayed % this.pagesOnSide;
  },
  methods: {
    ...mapMutations(["setNewPage"]),
    setMaxPage() {
      this.maxPage = Math.ceil(this.totalResults / this.selectedLimit);
      if (this.currentPage > this.maxPage) {
        this.setNewPage(this.maxPage);
      }
    },
    previous() {
      if (this.currentPage !== 1) {
        this.setNewPage(this.currentPage - 1);
      }
    },
    next() {
      if (this.currentPage !== this.maxPage) {
        this.setNewPage(this.currentPage + 1);
      }
    },
    first() {
      this.setNewPage(1);
    },
    last() {
      console.log(this.maxPage);
      console.log(this.currentPage);
      this.setNewPage(this.maxPage);
    },

    getPageArray() {
      const pages = [];
      let startPage = 1;
      let endPage = this.maxPage;

      if (this.maxPage <= this.pagesDisplayed) {
        // In this case, too few pages, so display them all
        startPage = 1;
        endPage = this.maxPage;
      } else if (this.currentPage <= this.pagesOnSide) {
        // In this case, currentPage is too close to the beginning
        endPage = 2 * this.pagesOnSide + this.pageLeftover;
      } else if (this.currentPage > this.maxPage - this.pagesOnSide) {
        // In this case, currentPage is too close to the end
        startPage = this.maxPage - this.pagesDisplayed + this.pageLeftover;
        endPage = this.maxPage;
      } else {
        startPage = this.currentPage - this.pagesOnSide;
        endPage = this.currentPage + this.pagesOnSide;
      }

      for (let i = startPage; i <= endPage; i++) {
        pages.push({
          label: i,
          isActive: this.currentPage === i,
        });
      }
      // console.log("Start", this.startPage);
      // console.log("End", this.endPage);
      // console.log("pages", pages);

      return pages;
    },
  },
};
</script>

<style scoped>
.search-paginator {
  display: flex;
  justify-content: center;
  --paginatorButtonSize: 38px;
}

.page-button {
  width: var(--paginatorButtonSize);
  height: var(--paginatorButtonSize);
  margin: 0 4px;
  background-color: var(--wwfOrange);
  color: var(--wwfWhite);
  font-size: 14px;
  font-weight: 600;
  text-align: center;
  vertical-align: middle;
  border-radius: 50%;
  border: 2px solid var(--wwfOrange);
  cursor: pointer;
  transition: all 0.2s;
}

.page-button:disabled {
  background-color: var(--wwfGreyA7);
  border: 2px solid var(--wwfGreyA7);
}

.page-button .icon {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
}

.active-page {
  background-color: var(--wwfWhite);
  color: var(--wwfOrange);
}

@media only screen and (max-width: 768px) {
  .search-paginator {
    --paginatorButtonSize: 32px;
  }
}

@media only screen and (max-width: 450px) {
  .search-paginator {
    --paginatorButtonSize: 28px;
  }
}

@media only screen and (max-width: 400px) {
  .search-paginator {
    --paginatorButtonSize: 26px;
  }
}
</style>


// WEBPACK FOOTER //
// searchPaginator.vue?0be341ec